import React, {useEffect, useState} from "react";
import _ from "lodash";
import XMarkIcon from "@heroicons/react/24/solid/XMarkIcon";
import {PINTEREST_PIN_INPUT_FIELDS} from "../../constants/pinterest-pin.constant";
import {addSinglePinterestPin, updateSinglePinterestPin} from "../../services/pinterest-pin-data.service";
import {handleFieldValueChanges, prepareInputFields} from "../../../common/utils/field-change-util";
import RenderFields from "../../../common/ui/render-fields";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";

const AddEditPinterestPin = ({
                                 selectedPinterestPin = {},
                                 refreshPinterestPinList,
                                 isAddPinterestPin = false,
                                 isEditPinterestPin = false
                             }) => {
    const [showModal, setShowModal] = useState(false);
    const [pinterestPin, setPinterestPin] = useState(selectedPinterestPin);
    const [saveInProgress, setSaveInProgress] = useState(false);
    const [pinterestPinFieldInputs, setPinterestPinFieldInputs] = useState(PINTEREST_PIN_INPUT_FIELDS);


    useEffect(() => {

        if (showModal) {
            if (isEditPinterestPin) {
                setPinterestPin(selectedPinterestPin);
            } else {
                setPinterestPin({});
            }
        }

    }, [showModal]);

    const handleConfirmAction = async () => {
        setSaveInProgress(true);

        const existingPinterestPin = {...pinterestPin};

        if (isEditPinterestPin) {
            await updateSinglePinterestPin(existingPinterestPin);
        } else {
            await addSinglePinterestPin(existingPinterestPin);
        }

        setSaveInProgress(false);
        refreshPinterestPinList();
        setShowModal(false);
    }

    const handlePinterestPinChanges = (event) => {
        let existingPinterestPin = {...pinterestPin};
        existingPinterestPin = handleFieldValueChanges(event, existingPinterestPin);

        const {name} = event.target;
        if (name === 'pinterestPinType') {
            const newFields = prepareInputFields(PINTEREST_PIN_INPUT_FIELDS, event.target, existingPinterestPin);
            setPinterestPinFieldInputs(newFields);
        }

        setPinterestPin(existingPinterestPin);
    }

    const handleCloseAction = () => {
        setShowModal(false);
    }

    return (
        <>
            {isAddPinterestPin &&
                <button
                    className="button-green px-2 py-1"
                    onClick={() => setShowModal(true)}>
                    Add Pinterest Pin
                </button>
            }

            {isEditPinterestPin &&
                <button
                    className="button-green-outline px-3 py-1"
                    onClick={() => setShowModal(true)}>
                    Edit
                </button>
            }

            {showModal ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-x-0 top-0 z-50 outline-none focus:outline-none">
                        <div className="relative w-1/2 my-6 mx-auto max-w-3xl">
                            {/*content*/}
                            <div
                                className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-gray-100 outline-none focus:outline-none">
                                {/*header*/}
                                <div
                                    className="flex items-start justify-between p-5 border-b border-solid rounded-t">
                                    <h3 className="text-lg font-semibold">
                                        {isAddPinterestPin &&
                                            <>Add Pinterest Pin</>
                                        }

                                        {isEditPinterestPin &&
                                            <>Edit Pinterest Pin</>
                                        }
                                    </h3>

                                    <div className="">
                                        <button
                                            className="button-gray-outline px-1 py-1"
                                            onClick={handleCloseAction}>
                                            <div className="">
                                                <XMarkIcon className="h-6 w-6"/>
                                            </div>
                                        </button>
                                    </div>
                                </div>
                                {/*body*/}
                                <div className="relative p-5 flex-auto">
                                    <div className="leading-relaxed">
                                        <div className="flex flex-wrap justify-start">
                                            <RenderFields
                                                parentForm={pinterestPin}
                                                handleDetailChanges={handlePinterestPinChanges}
                                                fieldList={_.groupBy(pinterestPinFieldInputs, 'group')['pinterestPin']}
                                                enableEdit={true}/>
                                        </div>

                                        <div className="flex flex-wrap justify-start">
                                            <RenderFields
                                                parentForm={pinterestPin}
                                                handleDetailChanges={handlePinterestPinChanges}
                                                fieldList={_.groupBy(pinterestPinFieldInputs, 'group')['detail']}
                                                enableEdit={true}
                                                fieldClassName={'w-full'}/>
                                        </div>

                                        <div className="flex flex-wrap justify-start">
                                            <RenderFields
                                                parentForm={pinterestPin}
                                                handleDetailChanges={handlePinterestPinChanges}
                                                fieldList={_.groupBy(pinterestPinFieldInputs, 'group')['filter']}
                                                enableEdit={true}
                                                fieldClassName={'w-1/2'}/>
                                        </div>
                                    </div>
                                </div>
                                {/*footer*/}
                                <div
                                    className="flex items-center justify-end p-5 border-t border-solid border-blueGray-200 rounded-b">
                                    <div className="ml-4 -mt-1">
                                        <ShowProgressSpinner dataFetchInProgress={saveInProgress}/>
                                    </div>
                                    <button
                                        className="ml-2 text-gray-500 font-bold border border-gray-500 h-8 rounded px-4 outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={() => setShowModal(false)}>
                                        Cancel
                                    </button>
                                    <button
                                        className="ml-2 bg-green-500 text-white active:bg-green-600 h-8 px-4 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={handleConfirmAction}>
                                        Confirm Pinterest Pin
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}
        </>
    );
}

export default AddEditPinterestPin
